// pdfConstants.js

// --- Page dimensions ---
export const PAGE_WIDTH = 595.28; // A4 width in points

// --- Margin helper ---
export const cmToPt = (cm) => cm * 28.35;

// --- Page margins ---
export const MARGIN_LEFT = cmToPt(1);    // 1 cm
export const MARGIN_RIGHT = cmToPt(1);  // 1 cm
export const MARGIN_Y = cmToPt(2);       // 2 cm — used for top
export const MARGIN_BOTTOM = cmToPt(1.4); // 1.4 cm — bottom (smaller than top)

// --- Content width inside margins ---
export const CONTENT_WIDTH = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT;

// --- Global layout constants ---
export const headerLeftMarginGlobal = 0;
export const headingGreenlineMargin = 5;
export const lineHeightGlobal = 1.25;
export const fontSizeParagraph = 11;
export const bottomMarginItemGlobal = 10;
export const GREEN_HEADER_MARGIN_TOP = MARGIN_Y / 4;
export const INTEND_GLOBAL = 15;

export const paragraphStyle = {
      font: "Lato",
      fontSize: fontSizeParagraph,
      lineHeight: lineHeightGlobal,
      alignment: "justify",
      margin: [0,0,0,bottomMarginItemGlobal],
      unbreakable: true
  };

export const easyReadParagraphStyle = {
      font: "Lato",
      fontSize: fontSizeParagraph,
      lineHeight: 1.35,
      alignment: "left",
      margin: [0,0,0,16],
      unbreakable: true
  };

// Extra top margin on every page so image-only pages match the breathing room
// of pages that open with a section heading. Headings cancel it with an equal
// negative top margin so their visual position stays unchanged.
export const SECTION_TOP_PAD = Math.round((18 + headingGreenlineMargin + 1 + bottomMarginItemGlobal) * 2 / 3); // ≈23pt

export const listStyle = {
      font: "Lato",
      fontSize: fontSizeParagraph,
      lineHeight: lineHeightGlobal*1.1,
      alignment: "left",
      margin: [INTEND_GLOBAL,0,0,bottomMarginItemGlobal]
  }